import { Link, useParams, useSearchParams, useOutletContext  } from "react-router-dom"
import { useComputed, useSignal } from "@preact/signals-react"

import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Spinner from 'react-bootstrap/Spinner'
import Stack from "react-bootstrap/esm/Stack.js"

import DebugAccordion from "../../components/DebugAccordion"
import ProfileNav from "./components/ProfileNav.jsx"
import ProfileTools from "./components/ProfileTools.jsx"
import PageTitle from "../../components/PageTitle.jsx"
import TimestampWithUTCTooltip from "../../components/TimestampWithUTCTooltip"

import useProfile from "../../hooks/useProfile.js"
import useSchemaManifest from "../../hooks/useSchemaManifest.js"

export default function ProfileDetail() {

    const [searchParams] = useSearchParams()
    const debug = !!searchParams.get('debug')
    const { beId, profileId } = useParams()
    const { config, accessToken, canEditSignal, accordionData: sidebarAccordionData  } = useOutletContext()
    const { manifest } = useSchemaManifest()

    const { profile, loading: profileLoading, isLoaded } = useProfile(beId, profileId, config, accessToken)

    const accordionData = [
        { name: 'Profile Data', data: profile },
        { name: 'Access Token', data: accessToken},
        { name: 'App Config', data: config},
        { name: 'Schema Manifest', data: manifest }
    ]

    if (!isLoaded.value) {
        return (
            <div className="d-flex justify-content-center">
                <Spinner className="mt-5 align-center" animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        )
    }

    return (
        <>
        <Breadcrumb className="px-3 pt-1 bg-light">
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/be/${beId}/profiles` }}>
                Profile List
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Manage {profile.value.componentProfile.name}</Breadcrumb.Item>
        </Breadcrumb>
        <Stack direction="horizontal" gap={3}>
            <PageTitle title={`Manage Profile ${profile.value.componentProfile.name}`} canEditSignal={canEditSignal} />
            <ProfileTools profile={profile.value}></ProfileTools>
        </Stack>
        <ProfileNav beId={beId} profileId={profileId} activeKey="1" debug={debug}></ProfileNav>
        <Form>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2" className="text-end">Profile Name</Form.Label>
                <Col sm="10"><Form.Control disabled readOnly value={profile.value.componentProfile.name} /></Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2" className="text-end">Profile Version</Form.Label>
                <Col sm="10"><Form.Control disabled readOnly value={profile.value.componentProfile.version} /></Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2" className="text-end">Parent Account</Form.Label>
                <Col sm="10"><Form.Control disabled readOnly value={profile.value.componentProfile.businessEntitySummary.name} /></Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="2" className="text-end">Created</Form.Label>
                    <Col sm="10"><span><TimestampWithUTCTooltip date={profile.value.componentProfile.createdAt}></TimestampWithUTCTooltip></span></Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2" className="text-end">Last Updated</Form.Label>
                    <Col sm="10"><span><TimestampWithUTCTooltip date={profile.value.componentProfile.lastUpdatedAt}></TimestampWithUTCTooltip></span></Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2" className="text-end">Last Applied</Form.Label>
                    <Col sm="10"><span><TimestampWithUTCTooltip date={profile.value.componentProfile.lastAppliedAt}></TimestampWithUTCTooltip></span></Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2" className="text-end">Id</Form.Label>
                <Col sm="10"><Form.Control disabled readOnly value={profile.value.componentProfile.id} /></Col>
            </Form.Group>
        </Form>
        <DebugAccordion data={accordionData} debug={debug} />
        </>
    )
}